import React from "react";

import { withRouter } from "react-router-dom";

import { Resources } from "../../contexts/ResourcesContext";
import Card, { CardMedia, CardPrimaryContent } from "@material/react-card";

class ProjectCell extends React.Component {
  navigate = () => {
    const { history, project } = this.props;
    history.push(`/p/${project.slug}`);
  };

  render() {
    const { project } = this.props;
    const image =
      project.slug in Resources.logos
        ? Resources.logos[project.slug]
        : Resources.images[project.slug];

    return (
      <div className="carousel-cell">
        <Card>
          <CardPrimaryContent onClick={this.navigate}>
            <CardMedia imageUrl={image} square />
            <div className="card-container">
              <h3 className="carousel-cell-title">{project.name}</h3>
            </div>
          </CardPrimaryContent>
        </Card>
      </div>
    );
  }
}

export default withRouter(ProjectCell);
